import React, { useState } from "react";

const StarRating = ({
  maxStars = 5,
  minStars = 1,
  defaultStars = 3,
  onChange,
  canChangeRating = true,
}) => {
  const [rating, setRating] = useState(defaultStars);

  const handleClick = (newRating) => {
    if (!canChangeRating) return;
    if (newRating < minStars) {
      newRating = minStars;
    } else if (newRating > maxStars) {
      newRating = maxStars;
    }
    setRating(newRating);
    if (onChange) {
      onChange(newRating);
    }
  };

  return (
    <div>
      {[...Array(maxStars)].map((_, index) => {
        const starValue = index + 1;
        return (
          <span
            key={index}
            onClick={() => handleClick(starValue)}
            className="m-1"
            style={{
              cursor: canChangeRating ? "pointer" : "default",
              color: starValue <= rating ? "gold" : "gray",
              fontSize: "15px",
            }}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;
